"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRelatedDocuments = exports.getDocumentHistory = exports.getWritableAttachmentUrl = exports.getWritableSignatureUrl = exports.getDocumentParticipants = exports.getDocumentOwners = exports.deleteDocumentPhotoById = exports.createOrUpdateDocumentPhoto = exports.deleteDocumentById = exports.getDocumentById = exports.getParticipantDocuments = exports.downloadDocuments = exports.getDocuments = exports.updateDocument = exports.shareDocument = exports.createDocument = void 0;
var network_1 = require("../network");
var utils_1 = require("../utils");
function createDocument(_a) {
    var document = _a.document;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePost({
                    path: "/documents",
                    body: document,
                })];
        });
    });
}
exports.createDocument = createDocument;
function shareDocument(_a) {
    var share = _a.share;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePost({
                    path: "/documents/share",
                    body: share,
                })];
        });
    });
}
exports.shareDocument = shareDocument;
function updateDocument(_a) {
    var document = _a.document;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePut({
                    path: "/documents",
                    body: document,
                })];
        });
    });
}
exports.updateDocument = updateDocument;
function getDocuments(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.simpleGet({
                    path: "/documents" + utils_1.buildQueryParams(params),
                })];
        });
    });
}
exports.getDocuments = getDocuments;
function downloadDocuments(params) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_a) {
            queryParams = utils_1.buildQueryParams(params, ["mediaType"]);
            return [2, network_1.simpleGetFile({
                    path: "/documents" + queryParams,
                    mediaType: params.mediaType,
                })];
        });
    });
}
exports.downloadDocuments = downloadDocuments;
function getParticipantDocuments(params) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_a) {
            queryParams = utils_1.buildQueryParams(params);
            return [2, network_1.simpleGet({
                    path: "/participants/" + params.participantId + "/documents" + queryParams,
                })];
        });
    });
}
exports.getParticipantDocuments = getParticipantDocuments;
function getDocumentById(_a) {
    var id = _a.id;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleGet({
                    path: "/documents/" + id,
                })];
        });
    });
}
exports.getDocumentById = getDocumentById;
function deleteDocumentById(_a) {
    var id = _a.id;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleDelete({
                    path: "/documents/" + id,
                })];
        });
    });
}
exports.deleteDocumentById = deleteDocumentById;
function createOrUpdateDocumentPhoto(_a) {
    var documentId = _a.documentId, photo = _a.photo;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePut({
                    path: "/documents/" + documentId + "/photos",
                    body: photo,
                })];
        });
    });
}
exports.createOrUpdateDocumentPhoto = createOrUpdateDocumentPhoto;
function deleteDocumentPhotoById(_a) {
    var documentId = _a.documentId, photoId = _a.photoId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleDelete({
                    path: "/documents/" + documentId + "/photos/" + photoId,
                })];
        });
    });
}
exports.deleteDocumentPhotoById = deleteDocumentPhotoById;
function getDocumentOwners(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.simpleGet({
                    path: "/documents/owners" + utils_1.buildQueryParams(params),
                })];
        });
    });
}
exports.getDocumentOwners = getDocumentOwners;
function getDocumentParticipants(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.simpleGet({
                    path: "/documents/participants" + utils_1.buildQueryParams(params),
                })];
        });
    });
}
exports.getDocumentParticipants = getDocumentParticipants;
function getWritableSignatureUrl(_a) {
    var documentId = _a.documentId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleGet({
                    path: "/documents/" + documentId + "/writable-signature-url",
                })];
        });
    });
}
exports.getWritableSignatureUrl = getWritableSignatureUrl;
function getWritableAttachmentUrl(_a) {
    var documentId = _a.documentId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleGet({
                    path: "/documents/" + documentId + "/writable-attachment-url",
                })];
        });
    });
}
exports.getWritableAttachmentUrl = getWritableAttachmentUrl;
function getDocumentHistory(_a) {
    var documentId = _a.documentId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleGet({
                    path: "/documents/" + documentId + "/history",
                })];
        });
    });
}
exports.getDocumentHistory = getDocumentHistory;
function getRelatedDocuments(_a) {
    var documentId = _a.documentId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleGet({
                    path: "/documents/" + documentId + "/related",
                })];
        });
    });
}
exports.getRelatedDocuments = getRelatedDocuments;
//# sourceMappingURL=documentResource.js.map